import React from "react";
import AutoComplete from "../../components/Autocomplete";

export const CounterpartySelect = ({
    value,
    onChange,
    fullWidth = true,
    fetchOptions,
    ...props
}) => {
    //autoSelect
    return (
        <AutoComplete
            fullWidth={fullWidth}
            {...props}
            fetchOptions={fetchOptions}
            getOptionLabel={(option) => option.name}
            value={value || null}
            onChange={(e, val) => {
                if (typeof val === "string") {
                    val = { name: val };
                }
                onChange && onChange(val);
            }}
            onBlur={(e) => {
                if (!value || !value.id) {
                    onChange && onChange(e.target.value ? { name: e.target.value } : null);
                }
            }}
            freeSolo
            clearable
        />
    );
};
